var linkToggle = document.querySelectorAll('.js-toggle');
var i = 0;

for(i = 0; i < linkToggle.length; i++) {
  linkToggle[i].addEventListener('click', function(event) {

    event.preventDefault();

    var container = document.getElementById(this.dataset.container);

    if (!container.classList.contains('active')) {
      this.classList.add('is-open');
      container.classList.add('active');
      container.style.height = 'auto';

      var height = container.clientHeight + 'px';

      container.style.height = '0px';

      setTimeout(function () {
        container.style.height = height;
      }, 0);
      
    } else {
      this.classList.remove('is-open');
      
      container.style.height = '0px';

      container.addEventListener('transitionend', function () {
        container.classList.remove('active');
      }, {
        once: true
      });
      
    }
    
  });

}

if (document.querySelectorAll('.first-item').length > 0) {
  document.querySelectorAll('.first-item').forEach(e=> {
    e.click();
  })
}


document.querySelectorAll('.read-more-link').forEach(e=> {
  e.addEventListener('click', (event)=> {
    event.preventDefault()
    var content = e.closest('.collapse-content')
    var p = content.querySelector('p');
    
    if (content.classList.contains('collapsed')) {
      content.classList.remove('collapsed');
      e.textContent = 'Read Less';
    } else {
      content.classList.add('collapsed');
      e.textContent = 'Read More';
    }
  })
})

document.querySelectorAll('.autoplay-slide').forEach(e=> {
  // Your code here
  const imageLinks = e
  const imageLinksItems = e.children[0];
  const parent = e.parentNode;
  const buttonNext = parent.querySelector('[is="next-button"]')

  let scrollLeft = 0;
  let currentItem = 0;
  const itemWidth = imageLinksItems.offsetWidth;
  const totalItems = imageLinksItems.length;
 
  function scroll() {
    if (buttonNext.hasAttribute('disabled')) {
      // If the last item is reached, reset the scroll position
      scrollLeft = 0;
      currentItem = 0;
    } else {
      // Scroll to the next item
      scrollLeft += itemWidth;
      currentItem++;
    }
    
    // Use scrollLeft to scroll
    imageLinks.scrollLeft = scrollLeft;
  }

  // Automatically scroll every 3 seconds
  setInterval(scroll, 3000);
})




document.querySelectorAll('.play-button-pop .button').forEach(e=> {
  e.addEventListener('click', function(el) {
    el.preventDefault()
  })
})


        // Function to create and show the modal
        function showModal(videoId,parent) {
          const noscript = parent.querySelector('noscript')

          const modal = document.createElement('div');
          modal.classList.add('modal');

          if (noscript != null) {
            modal.innerHTML = `
            <div class="modal-pop-inner">
              <div class="frame-wrapper">
                ${noscript !== null ? noscript.textContent : ''}
              </div>
            </div>
          `;
          } else {
            modal.innerHTML = `
            <div class="modal-pop-inner">
              <div class="frame-wrapper">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allowfullscreen></iframe>
              </div>
            </div>
          `;
          }


          const overlay = document.getElementById('overlay');
          overlay.appendChild(modal);
          document.body.classList.add('active-pop')

          // Remove modal and overlay when clicking the overlay
          overlay.addEventListener('click', function() {
              overlay.removeChild(modal);
              document.body.classList.remove('active-pop')
          });
      }

      // Attach click event to all elements with the class "play-button-pop"
      const playButtons = document.querySelectorAll('.play-button-pop');
      playButtons.forEach(button => {
          button.addEventListener('click', function(event) {
              event.preventDefault();
              const videoId = this.querySelector('.button').getAttribute('href');
              const parent = this.closest('.play-button-pop')
              showModal(videoId, parent);
          });
      });

if ($(".featured-product-section.index").length > 0) {
  const interval = setInterval(function () {
    const rcWeiget = $(".rc_container_wrapper").length;
    const rcContentTab = $('.rc-onetime-content sale-price');
    if (rcWeiget > 0 && rcContentTab) {
      
          let featured_products_sections = $('.shopify-section--featured-product');
          for (let i = 0; i < featured_products_sections.length; ++i) {
            let featured_products_sections_id = featured_products_sections[i].getAttribute('id');
            const rcPrice = $( '#' + featured_products_sections_id + ' .product-info .product-info__price').data("sprice");
            
            
            setTimeout(function(){
              const originalPrice = $( '#' + featured_products_sections_id + ' .product-info .product-info__price').data("originalprice");
              
              $( '#' + featured_products_sections_id + ' .product-info__price sale-price.main-price-sale').text(originalPrice);
              $( '#' + featured_products_sections_id + ' .rc-onetime-content sale-price.text-subdued.org-prr.recharge-inner-most-price').text(originalPrice);
            }, 100);
            
              $( '#' + featured_products_sections_id + ' .rc-option__onetime').addClass('cancel-pointer-events');
              $( '#' + featured_products_sections_id + ' .rc-option__subsave').removeClass('cancel-pointer-events');
            
            
            
            console.log("rcPrice ", rcPrice);
            $('#' + featured_products_sections_id + ' .one-price').text(rcPrice);
            $( '#' + featured_products_sections_id + ' .rc-subs-content price-list.price-list').prepend(
              `<div class="custom-sale-price">${rcPrice}</div>`
            );
          }
       
      clearInterval(interval);
    }
  }, 1000);

  $(document).on('change','.rc-radio-group__options .rc-radio input', function(){
    const sType = $(this).val();
    const section_id = $(this).closest('section').attr('id');
    
    setTimeout(function(){
    console.log('sType ',sType);
   
    if(sType == 'onetime'){
        const onetimePrice = $( '#' + section_id + ' .rc-subs-content compare-at-price').text().replace(' Regular price','');
        $('#' + section_id + ' .rc-onetime-content sale-price').text(onetimePrice);
        $('#' + section_id + ' .product-info__price sale-price').text(onetimePrice);
        $('#' + section_id + ' .rc-option__onetime').addClass('cancel-pointer-events');
        $('#' + section_id + ' .rc-option__subsave').removeClass('cancel-pointer-events');
        const rcPrice = $('#' + section_id + " .product-info .product-info__price").data("sprice");
        $('#' + section_id + ' .one-price').text(rcPrice);
    }else{
      const rcPrice = $('#' + section_id + " .product-info .product-info__price").data("sprice");
      console.log("rcPrice ", rcPrice);
       $('#' + section_id + ' .product-info__price sale-price').text(rcPrice);
       $('#' + section_id + ' .rc-option__onetime').removeClass('cancel-pointer-events');
       $('#' + section_id + ' .rc-option__subsave').addClass('cancel-pointer-events');
    }
  },100);
});

  $('button.feat-button').click(function(){
    let product_id = $(this).data('product-id');
    let featured_product_section = $('div[data-product-tab="' + product_id + '"]').closest('section');
    let featured_products_sections_id = featured_product_section.attr('id');
    const originalPrice = $( '#' + featured_products_sections_id + ' .product-info .product-info__price').data("originalprice");        
    $( '#' + featured_products_sections_id + ' .product-info__price sale-price.main-price-sale').text(originalPrice);
    $( '#' + featured_products_sections_id + ' .rc-onetime-content sale-price.text-subdued.org-prr.recharge-inner-most-price').text(originalPrice);
    const rcPrice = $('#' + featured_products_sections_id + " .product-info .product-info__price").data("sprice");
    $('#' + featured_products_sections_id + ' .one-price').text(rcPrice);
    if($( '#' + featured_products_sections_id + ' .rc_widget__option__input--subsave').is(':checked')){
      $('#' + featured_products_sections_id + ' .product-info__price sale-price').text(rcPrice);
    }
    
  });
}
/* update selling plan on cart */
document.querySelectorAll('.subscription__update-select').forEach(function(select) {
select.addEventListener('change', function(event) {
const lineItemKey = event.target.getAttribute('data-line-key');
const selectedSellingPlanId = event.target.value;

fetch('/cart/change.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({
id: lineItemKey,
selling_plan: selectedSellingPlanId,
quantity: 1
})
})
.then(response => response.json())
.then(cart => {
// Optionally, refresh the cart or update UI
location.reload();
})
.catch(error => console.error('Error updating cart:', error));
});
});
